import React from 'react';
const WhyAiSecurityGovernance = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why AI Security & Governance Now?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            AI adoption is outpacing security enterprises deploy LLMs and autonomous agents faster than they can govern them. Unmonitored models leak sensitive data, adversarial attacks manipulate predictions, and prompt injection exploits bypass safety controls. These aren&apos;t theoretical risks; they&apos;re documented incidents costing millions in fines and reputational damage. Regulations have shifted from voluntary to mandatory. The EU AI Act imposes penalties up to €35 million or 7% of revenue, while GDPR now explicitly covers AI systems. Without governance, organizations face failed audits, regulatory sanctions, and blocked launches.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-4 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Common barriers include shadow AI proliferation, missing audit trails, undetected bias triggering discrimination lawsuits, and no accountability when systems fail. Typical scenarios include financial institutions providing compliance for audits, healthcare providers securing patient data in AI diagnostics, and manufacturers protecting proprietary models from theft.
                        </p>
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            That&apos;s where we help implement model registries, hardening LLM systems against attacks, automating compliance reporting, and building responsible AI programs with security and accountability built in.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyAiSecurityGovernance;
